var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"w-full flex items-center"},[_c('div',{staticClass:"pr-8 flex-grow"},[_c('label',{staticClass:"pt-2 inline-block font-bold"},[_vm._v(_vm._s(_vm.question.question))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }